<template>
  <div class="login-popup">
    <div class="popup-shadow" @click="hideLoginPopup"></div>
    <div class="popup-container">
      <img class="login-bg" v-if="loginBg" :src="loginBg" alt="login-bg" />
      <div class="login-type" v-if="isJpPlatform">
        <div
          class="login-type-item"
          :class="{ active: jpUidLogin || isRoleIdLogin }"
          @click="selectUidOrRoleIdLogin"
        >
          ID番号
        </div>
        <div class="login-type-item-line"></div>
        <div
          class="login-type-item"
          :class="{ active: isJpUidTokenLogin }"
          @click="setLoginTypeTrue('isJpUidTokenLogin')"
        >
          LoginPassログイン
        </div>
      </div>
      <div class="login-title" v-else>{{ titleText }}</div>
      <!-- 游客有otp登录 -->
      <uid-token-login
        v-if="defaultLogin == loginTypeMap.GUEST"
        :isJpUidTokenLogin="isJpUidTokenLogin"
        :jpUidLogin="jpUidLogin"
        :isRoleIdLogin="isRoleIdLogin"
        @setLoginTypeTrue="setLoginTypeTrue"
      ></uid-token-login>
      <!-- 账密登录 -->
      <account-login
        v-if="defaultLogin == loginTypeMap.ACCOUNT_LOGIN"
      ></account-login>
      <!-- 游客无otp登录 先隐藏后续确认显示条件后打开 -->
      <!-- <visitor-login></visitor-login> -->
      <third-party-login v-if="!isJpPlatform"></third-party-login>
      <protocol-link></protocol-link>
      <Icon
        v-if="showHelpBtn"
        class="help-btn"
        name="help"
        @click="clickHelp"
      />
    </div>

    <transition name="fade">
      <uid-token-guide-popup
        v-if="!isJpPlatform"
        v-show="showGuide"
        @hidePopup="showGuide = false"
      ></uid-token-guide-popup>
    </transition>
    <transition name="fade">
      <PopupWindow
        v-if="showPopup"
        @onCancel="showPopup = false"
        @onConfirm="showPopup = false"
        type="tips"
        :languages="letter"
        :title="letter.thirdInfo"
        :content="letter.thirdInfoContent"
        class="bank-tip-popup"
      ></PopupWindow>
    </transition>
    <!-- 江美专属弹窗 -->
    <beauty-token-guide-popup
      v-bind:visible.sync="visibleBeautyTokenGuide"
    ></beauty-token-guide-popup>
    <beauty-uid-guide-popup
      v-bind:visible.sync="visibleBeautyUidGuide"
      :isRoleIdLogin="isRoleIdLogin"
    ></beauty-uid-guide-popup>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import UidTokenLogin from '@components/officialTopupNew/login/UidTokenLogin.vue';
import AccountLogin from '@components/officialTopupNew/login/AccountLogin.vue';
import VisitorLogin from '@components/officialTopupNew/login/VisitorLogin.vue';
import ThirdPartyLogin from '@components/officialTopupNew/login/ThirdPartyLogin.vue';
import ProtocolLink from '@components/officialTopupNew/login/ProtocolLink.vue';
import BeautyUidGuidePopup from '@components/officialTopupNew/login/BeautyUidGuidePopup.vue';
import BeautyTokenGuidePopup from '@components/officialTopupNew/login/BeautyTokenGuidePopup.vue';
import UidTokenGuidePopup from '@components/officialTopupNew/login/UidTokenGuidePopup.vue';

import login from '@mixins/officialTopupNew/login';
const LOGIN_TYPE_MAP = {
  ACCOUNT_LOGIN: 1,
  GUEST: 2
};
export default {
  name: 'LoginPopup',
  mixins: [login],
  data() {
    return {
      loginTypeMap: LOGIN_TYPE_MAP,
      showGuide: false,
      showPopup: false,
      visibleBeautyTokenGuide: false,
      visibleBeautyUidGuide: false,
      jpUidLogin: false,
      isRoleIdLogin: false,
      isJpUidTokenLogin: false
    };
  },
  computed: {
    ...mapState({
      visibleTokenLoginPopup: state => state.visibleTokenLoginPopup,
      letter: state => state.letter,
      gameId: state => state.gameId,
      picList: state => state.page.picList
    }),
    ...mapGetters(['isJpPlatform']),
    loginBg() {
      return this.picList?.loginbanner || '';
    },
    curShowLoginType() {
      // 判断是跟随游戏配置还是跟支付页配置
      return this.isFollowGameLogin ? this.defaultLogin : this.showLoginType;
    },
    titleText() {
      let text = this.letter.login;
      if (+this.defaultLogin !== this.loginTypeMap.ACCOUNT_LOGIN) {
        text = 'OTP TOKEN';
      }
      if (this.isJpPlatform) {
        text = this.isJpUidLogin
          ? this.letter.storeAccountIdLogin
          : 'LoginPassログイン';
      }
      return text;
    },
    showHelpBtn() {
      return (
        this.isJpPlatform ||
        Object.keys(this.$store.state.page.otpPicList).length > 0
      );
    }
  },
  created() {
    if (this.isJpPlatform) {
      this.isRoleIdLogin = true;
    }
  },
  methods: {
    clickHelp() {
      // 日本平台 江美专属弹窗
      if (this.isJpPlatform) {
        if (this.isRoleIdLogin || this.jpUidLogin) {
          this.visibleBeautyUidGuide = true;
        } else {
          this.visibleBeautyTokenGuide = true;
        }
        return;
      }
      if (this.defaultLogin == this.loginTypeMap.GUEST) {
        this.showGuide = true;
      }
      if (this.defaultLogin == this.loginTypeMap.ACCOUNT_LOGIN) {
        this.showPopup = true;
      }
    },
    selectUidOrRoleIdLogin() {
      this.setLoginTypeTrue(
        this.isRoleIdLogin ? 'isRoleIdLogin' : 'jpUidLogin'
      );
    },
    setLoginTypeTrue(type) {
      this[type] = true;
      ['jpUidLogin', 'isRoleIdLogin', 'isJpUidTokenLogin'].forEach(key => {
        if (key !== type) {
          this[key] = false;
        }
      });
    }
  },
  components: {
    UidTokenLogin,
    ThirdPartyLogin,
    ProtocolLink,
    AccountLogin,
    VisitorLogin,
    UidTokenGuidePopup,
    BeautyUidGuidePopup,
    BeautyTokenGuidePopup
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
.login-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
}
.popup-shadow {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}
.popup-container {
  position: relative;
  box-sizing: border-box;
  border-radius: 20px;
  background: #fff;
}
.login-bg {
  width: 100%;
  border-radius: 20px 20px 0 0;
}

.login-title {
  padding: 40px 40px 50px;
  text-align: center;
  line-height: 1.2;
  font-size: 28px;
  margin: 0;
  border-radius: 20px;
  font-weight: bold;
  color: #333333;
}
.login-type {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  &-item {
    width: 50%;
    text-align: center;
    font-size: 24px;
    color: #333;
    cursor: pointer;
    &.active {
      color: $themeColor;
    }
    &-line {
      border-left: 1px solid #333;
      height: 27px;
      vertical-align: middle;
      border-top: 0;
    }
  }
}

.login-type-wrap {
  display: flex;
  justify-content: center;
  line-height: 1.2;
  margin-bottom: 15px;
  align-items: center;
  .login-type {
    position: relative;
    font-size: 24px;
    color: #666666;
    width: 50%;
    padding-bottom: 16px;
    cursor: pointer;
    &:hover {
      font-weight: bold;
    }
    &.active {
      font-weight: bold;
      color: #333333;
    }
    &-tip {
      font-size: 22px;
      border-radius: 6px;
      box-sizing: border-box;
      padding: 10px 20px;
      text-align: center;
      line-height: 1.2;
      background-color: #ececec;
      margin: 0 36px;
    }
    .underline-wrap {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 4px;
    }
    .underline {
      width: 58px;
      height: 4px;
      background-color: $themeColor;
    }
  }
}

.help-btn {
  position: absolute;
  left: 40px;
  bottom: 59px;
  color: #333333;
  width: 34px;
  height: 34px;
  cursor: pointer;
}

#ssr-page.landscape {
  .popup-container {
    width: $landscapePopupWidth;
    ::v-deep .uid-token-content {
      width: 100%;
    }
    ::v-deep .third-login .space .line {
      width: 368px;
    }
  }
  .title {
    height: 61px;
    line-height: 61px;
    font-size: 22px;
  }
}
</style>
